define('webshopAttributesMatchingView',[
  'module',
  'backbone',
  'marionette',
  'underscore',
  'buttonView',
  'modalView',
  'modalsAlertView',
  'webshopAttributesKeyView',
  'webshopAttributesEditView',
  'entities/webshop/attribute_matching',
  'template!webshopAttributesMatchingView'
], function (
  Module,
  Backbone,
  Marionette,
  _,
  ButtonView,
  ModalView,
  AlertView,
  KeyView,
  EditView,
  MatchingApi,
  Tpl
) {
  'use strict';

  // Left: the canonical attributes of the account (searched client-side). Right: the selected one.
  // options.meta: {languages, suppliers}
  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'webshop-attributes-matching-view',

    regions: {
      addRegion: '.add-region',
      detailRegion: '.detail-region'
    },

    ui: {
      search: 'input.search',
      onlyFilters: 'input.only-filters',
      list: '.keys'
    },

    events: {
      'input @ui.search': 'renderList',
      'change @ui.onlyFilters': 'renderList',
      'click .key': 'onSelect'
    },

    initialize: function () {
      this.keys = [];
      this.selectedId = null;
    },

    onShow: function () {
      var addButton = new ButtonView({
        type: 'add',
        color: 'orange',
        text: _.i18n('attributeMatching.addKey', null, 'New attribute')
      });
      addButton.on('click', _.bind(this.onAdd, this));
      this.getRegion('addRegion').show(addButton);
      this.fetch();
    },

    fetch: function () {
      this.ui.list.addClass('am-loading');
      return MatchingApi.keys().done(_.bind(function (keys) {
        this.keys = keys || [];
        if (this.isDestroyed)
          return;
        this.renderList();
        // First load: the attribute of the URL
        var state = this.options.state || {};
        if (!this.restored && state.key) {
          this.restored = true;
          this.showKey(parseInt(state.key, 10), state);
        }
      }, this)).fail(function (message) {
        AlertView.prototype.open('', message);
      }).always(_.bind(function () {
        if (!this.isDestroyed)
          this.ui.list.removeClass('am-loading');
      }, this));
    },

    setState: function (changes) {
      this.lastKeyState = _.extend({}, this.lastKeyState, changes);
      if (this.options.onState)
        this.options.onState(changes);
    },

    renderList: function () {
      var query = (this.ui.search.val() || '').toLowerCase();
      var onlyFilters = this.ui.onlyFilters.is(':checked');

      var keys = _.filter(this.keys, function (k) {
        if (onlyFilters && !k.showInFilters)
          return false;
        return !query || (k.code + ' ' + _.values(k.names).join(' ')).toLowerCase().indexOf(query) !== -1;
      });
      keys = _.sortBy(keys, function (k) { return MatchingApi.name(k).toLowerCase(); });

      var html = _.map(keys, function (k) {
        return '<div class="key ' + (k.id === this.selectedId ? 'selected' : '') + '" data-id="' + k.id + '">' +
          '<div class="line"><span class="name">' + _.escape(MatchingApi.name(k)) + '</span>' +
          '<span class="am-badge ' + (k.showInFilters ? 'on' : '') + '">' + _.escape(_.i18n('attributeMatching.filter', null, 'Filter')) + '</span></div>' +
          '<div class="line infos"><span class="code">' + _.escape(k.code) + '</span>' +
          '<span class="counts">' + k.valueCount + ' ' + _.escape(_.i18n('attributeMatching.values', null, 'values')) +
          ' · ' + k.supplierFieldCount + ' ' + _.escape(_.i18n('attributeMatching.supplierFields', null, 'supplier fields')) + '</span></div>' +
          '</div>';
      }, this).join('');

      this.ui.list.html(html || '<div class="empty">' + _.i18n('attributeMatching.noKey', null, 'No attribute') + '</div>');
    },

    onSelect: function (e) {
      this.showKey(parseInt($(e.currentTarget).data('id'), 10));
    },

    // state: the URL state to restore in the attribute (sub tab, supplier values filters)
    showKey: function (id, state) {
      this.selectedId = id;
      this.$('.key').removeClass('selected');
      this.$('.key[data-id="' + id + '"]').addClass('selected');

      var key = _.findWhere(this.keys, {id: id});
      if (!key)
        return;
      if (!state)
        this.setState({key: id, sub: null, q: null, sup: null, unm: null});

      this.getRegion('detailRegion').show(new KeyView({
        key: key,
        meta: this.options.meta,
        state: state || {},
        onState: _.bind(this.setState, this),
        onChanged: _.bind(function (updated) {
          this.fetch().done(_.bind(function () {
            if (updated)
              this.showKey(updated.id, this.lastKeyState);
          }, this));
        }, this),
        onDeleted: _.bind(function () {
          this.selectedId = null;
          this.setState({key: null, sub: null, q: null, sup: null, unm: null});
          this.getRegion('detailRegion').empty();
          this.fetch();
        }, this)
      }));
    },

    onAdd: function () {
      ModalView.prototype.open({
        childView: EditView,
        kind: 'key',
        languages: this.options.meta.languages,
        model: new Backbone.Model({code: '', names: {}, showInFilters: true, showInAttributes: true}),
        title: _.i18n('attributeMatching.addKey', null, 'New attribute'),
        confirmButtonText: _.i18n('common.create', null, 'Create'),
        onConfirm: _.bind(function (model) {
          MatchingApi.addKey(model.toJSON()).done(_.bind(function (key) {
            this.fetch().done(_.bind(function () {
              this.showKey(key.id);
            }, this));
          }, this)).fail(function (message) {
            AlertView.prototype.open('', message);
          });
        }, this)
      });
    }
  });
});

